import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter
} from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { AnimalsTableService } from 'src/app/modules/acbcr/common/services/animals-table.service';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import {
  evaluareGeneticaNumber,
  evaluareGeneticaPercent,
  evaluareGeneticaColumnsDesc
} from 'src/app/modules/acbcr/components/pages/evaluare-genetica/evaluare-genetica.component'

@Component({
  selector: 'app-performanta-form-block',
  templateUrl: './performanta-form-block.component.html',
})
export class PerformantaFormBlockComponent implements OnInit, OnChanges {
  @Input() animalForm: UntypedFormGroup;
  @Input() disabledFields = {};
  @Input() evaluareGenetica;
  @Input() submitted: boolean;
  @Output() openBonitareModal = new EventEmitter();

  bonitareType: string;
  openBonitare = false;

  ev_gen_cols = [
    'consangvinizare',
    'va_absolut_greutate_nastere',
    'va_relativ_greutate_nastere',
    'acc_greutate_nastere',
    'va_absolut_greutate_intarcare',
    'va_relativ_greutate_intarcare',
    'acc_greutate_intarcare',
    'va_absolut_greutate_smz',
    'va_relativ_greutate_smz',
    'acc_smz',
    'ebv_carne_absolut',
    'ebv_carne_relativ',
    'acc_carne',
    'va_absolut_greutate_nota_fatare',
    'va_relativ_greutate_nota_fatare',
    'acc_nota_fatare',
    'ebv_reproductie_absolut',
    'ebv_reproductie_relativ',
    'acc_reproductie',
    'ebv_total_absolut',
    'ebv_total_relativ',
    'acc_total',
    'data'
  ];
  number = evaluareGeneticaNumber;
  percent = evaluareGeneticaPercent;
  columnsDesc = evaluareGeneticaColumnsDesc;

  constructor(
    private helperDataService: HelperDataService,
    private animalTableService: AnimalsTableService
    ) {
  }

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.animalForm.value.id) {
        this.checkDocumentValidators();
    }
  }

  get form() {
    return this.animalForm.controls;
  }

  uploadServerResponseFisaBonitare(event) {
    const file = event.body.files[0];
    this.form.fileidfisabonitare.setValue(file.file_id);
    this.form.filename_fisabonitare.setValue(file.file_uploaded_name);
  }

  uploadServerResponseApreciereFenotipica(event) {
    const file = event.body.files[0];
    this.form.file_id_apr_feno.setValue(file.file_id);
    this.form.file_name_apr_feno.setValue(file.file_uploaded_name);
    this.checkDocumentValidators();
  }

  downloadFisaBonitare() {
    const fileId = this.form.fileidfisabonitare.value;
    const fileName = this.form.filename_fisabonitare.value;

    this.helperDataService.downloadFile(fileId)
      .subscribe((response: any) => {
        const blob = new Blob([response]);
        this.helperDataService.simulateDownload(blob, fileName);
      });
  }

  downloadApreciereFenotipica() {
    const fileId = this.form.file_id_apr_feno.value;
    const fileName = this.form.file_name_apr_feno.value;

    this.helperDataService.downloadFile(fileId)
      .subscribe((response: any) => {
        const blob = new Blob([response]);
        this.helperDataService.simulateDownload(blob, fileName);
      });
  }

  deleteFisaBonitare() {
    this.form.fileidfisabonitare.reset();
    this.form.filename_fisabonitare.reset();
  }

  deleteApreciereFenotipica() {
    this.form.file_id_apr_feno.reset();
    this.form.file_name_apr_feno.reset();
    this.form.docnr_apr_feno.reset();
    this.form.data_apr_feno.reset();
    this.checkDocumentValidators();
  }

  documentDataChanged(event) {
    this.form.data_apr_feno.setValue(event);
  }

  private checkDocumentValidators() {
    if (this.form.file_id_apr_feno.value) {
      this.form.data_apr_feno.setValidators(Validators.required);
      this.form.docnr_apr_feno.setValidators(Validators.required);
    } else {
      this.form.data_apr_feno.clearValidators();
      this.form.docnr_apr_feno.clearValidators();
    }

    this.form.data_apr_feno.updateValueAndValidity();
    this.form.docnr_apr_feno.updateValueAndValidity();
  }

  openModalBonitare(type) {
    this.bonitareType = type;
    this.openBonitare = true;
    this.openBonitareModal.emit(true);
  }

  closeBonitareModal(event) {
    this.openBonitare = event;
    this.openBonitareModal.emit(false);
  }

  dmValue(event) {
    this.animalForm.controls.dm.setValue(event);
  }

  dsValue(event) {
    this.animalForm.controls.ds.setValue(event);
  }

  afValue(event) {
    this.animalForm.controls.af.setValue(event);
  }
}
